import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-audioricette-box',
  templateUrl: './audioricette-box.component.html',
  styleUrls: ['./audioricette-box.component.scss']
})
export class AudioricetteBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
